import '.m{background-color:#1A1A29;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.o{padding:3rem 0;}.ssr-plugin'
import '.p{color:var(--palette-white);}.ssr-plugin'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TextLink } from '@app/components/core/link/TextLink'

export const Footer = () => {
  const isMobile = useMediaQuery()
  const { title, email, phone } = useTenantContext()
  const t = useTranslations().app.steunpuntAmsterdam

  return (
    <footer className="m n o p"
    >
      <ResponsiveContainer
        style={{
          margin: '0 auto',
          display: 'flex',
          flexDirection: isMobile ? 'column-reverse' : 'row',
          gap: '2rem',
          justifyContent: 'space-between',
        }}
      >
        <Column gap="2rem" style={{ maxWidth: '20rem', flex: '0 0 auto' }}>
          <div>
            <Title.H5>{title}</Title.H5>
            <p>{t.footer.description}</p>
          </div>
          <Text.Small>
            © {new Date().getFullYear()} {title} Amsterdam
          </Text.Small>
        </Column>

        <Column style={{ flex: '0 0 auto' }}>
          <Text.Medium>{t.footer.contactHeader}</Text.Medium>
          {email && (
            <a
              href={`mailto:${email}`}
              style={{ color: 'var(--palette-white)' }}
            >
              {email}
            </a>
          )}
          {phone && (
            <a href={`tel:${phone}`} style={{ color: 'var(--palette-white)' }}>
              {phone}
            </a>
          )}
        </Column>

        <Column style={{ flex: '0 0 auto' }}>
          <Text.Medium>{t.footer.platformHeader}</Text.Medium>
          <span>{t.footer.dataVia} CrowdBuilding</span>
          <TextLink
            to="https://www.crowdbuilding.com"
            target="_blank"
            containerStyle={{ color: 'var(--brand-primary)' }}
          >
            crowdbuilding.com
          </TextLink>
        </Column>
      </ResponsiveContainer>
    </footer>
  )
}
